module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MDAiIGhlaWdodD0iNjAwIj48cGF0aCBmaWxsPSIjMERCMDJCIiBkPSJNMCAwaDcwMHY2MDBIMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAwaDcwMHY0MDBIMHoiLz48cGF0aCBmaWxsPSIjZTA1MjA2IiBkPSJNMCAwaDcwMHYyMDBIMHoiLz48Y2lyY2xlIGN4PSIzNTAiIGN5PSIzMDAiIHI9Ijg1IiBmaWxsPSIjZTA1MjA2Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ner.svg
// module id = M3Mn
// module chunks = 0